import React, { useEffect, useState } from 'react'
import Input from '../../components/input';
import useAxiosInstance from '../../hooks/useAxios';
// import JsonView from '@uiw/react-json-view';
import { toast } from 'react-toastify';

const ImageGen = () => {
    const [prompt_text, set_prompt_text] = useState('');
    const [model_label, set_model_label] = useState('');
    const [resolution, set_resolution] = useState('1024x1024');
    const [quality, set_quality] = useState('standard');

    const axiosInstance = useAxiosInstance();

    const [library, set_library] = useState('');
    const [library_options, set_library_options] = useState([]);

    const [provider, set_provider] = useState('');
    const [provider_options, set_provider_options] = useState([]);

    const [model, set_model] = useState({});
    const [model_options, set_model_options] = useState([]);

    const [response, setResponse] = useState({});
    const [responseLoading, setResponseLoading] = useState(false);

    useEffect(() => {
        axiosInstance.get('wkl/llm/get_library/').then(res =>
            set_library_options(res?.data?.data || [])
        ).catch(err => {
            console.error('Error fetching libraries:', err);
        });
    }, []);

    useEffect(() => {
        if (!library) return;
        axiosInstance.get(`wkl/llm/get_provider/?library_pk=${library}`).then(res =>
            set_provider_options(res?.data?.data || [])
        ).catch(err => {
            console.error('Error fetching providers:', err);
        });
    }, [library]);

    useEffect(() => {
        if (!provider) return;
        axiosInstance.get(`wkl/llm/get_models/?provider_pk=${provider}`).then(res => {
            set_model_options(res?.data?.data || []);
        }).catch(err => {
            console.error('Error fetching models:', err);
        });
    }, [provider]);

    useEffect(() => {
        if (!model) return;

        let resolutionOptions = [];
        let qualityOptions = [];

        if (model.meta && model.meta.resolution_options) {
            resolutionOptions = model.meta.resolution_options.map(opt => opt.value);
        }

        if (model.meta && model.meta.quality_options) {
            qualityOptions = model.meta.quality_options.map(opt => opt.value);
        }

        if (resolutionOptions.length > 0) {
            set_resolution(resolutionOptions[0]);
        } else {
            set_resolution('1024x1024');
        }

        if (qualityOptions.length > 0) {
            set_quality(qualityOptions[0]);
        } else {
            set_quality('standard');
        }

        set_model_label(model.label || '');
    }, [model]);

    const handleGenerateImage = () => {
        if (!prompt_text.trim()) {
            toast.error('Please enter a prompt');
            return;
        }
        
        if (!model_label) {
            toast.error('Please select a model');
            return;
        }

        setResponseLoading(true);
        axiosInstance.post('wkl/image_generation/generate_image/', {
            prompt_text,
            model_label,
            resolution,
            quality
        })
        .then(response => {
            setResponse(response.data);
            setResponseLoading(false);

            if (response.data && (response.data.url || response.data.data)) {
                toast.success('Image generated successfully!');
            }
        })
        .catch(error => {
            console.error('Error generating image:', error);
            setResponseLoading(false);
            toast.error('Error generating image: ' + (error.response?.data?.message || error.message || 'Unknown error'));
        });
    };


    return (
        <div className='mx-4 py-4 '>
            <p className='text-lg px-3 py-2 rounded-lg bg-white border w-full font-semibold'>Image Generator</p>
            <div className={'bg-slate-100 p-6 rounded-b-lg'}>
                <div className='mt-4'>
                    <span className='text-sm font-semibold block mb-2'>
                        Library
                    </span>
                    <select
                        className="border rounded-lg px-3 py-2 w-full focus:ring-0 focus:outline-gray-400 disabled:bg-gray-300"
                        value={library}
                        onChange={(e) => set_library(e.target.value)}
                    >
                        <option value="">Choose</option>
                        {library_options.map(elem => (
                            <option key={elem.pk} value={elem.pk}>{elem.label}</option>
                        ))}
                    </select>

                    <span className='text-sm font-semibold block mb-2 mt-4'>
                        Provider
                    </span>
                    <select
                        className="border rounded-lg px-3 py-2 w-full focus:ring-0 focus:outline-gray-400 disabled:bg-gray-300"
                        value={provider}
                        onChange={(e) => set_provider(e.target.value)}
                        disabled={!library}
                    >
                        <option value="">Choose</option>
                        {provider_options.map(elem => (
                            <option key={elem.pk} value={elem.pk}>{elem.label}</option>
                        ))}
                    </select>

                    <span className='text-sm font-semibold block mb-2 mt-4'>
                        Model
                    </span>
                    <select
                        className="border rounded-lg px-3 py-2 w-full focus:ring-0 focus:outline-gray-400 disabled:bg-gray-300"
                        value={model.label || ''}
                        onChange={(e) => {
                            const selectedModel = model_options.find(m => m.label === e.target.value);
                            set_model(selectedModel || {});
                        }}
                        disabled={!provider}
                    >
                        <option value="">Choose</option>
                        {model_options.map(elem => (
                            <option key={elem.label} value={elem.label}>{elem.label}</option>
                        ))}
                    </select>

                    <span className='text-sm font-semibold block mb-2 mt-4'>
                        Prompt Text
                    </span>
                    <Input
                        type='text__area'
                        value={prompt_text}
                        onChange={e => set_prompt_text(e.target.value)}
                        placeholder="Describe the image you want to generate..."
                        disabled={!model}
                    />

                    <div className='grid grid-cols-2 gap-4 mt-4'>
                        <div>
                            <span className='text-sm font-semibold block mb-2'>
                                Resolution
                            </span>
                            <select
                                className="border rounded-lg px-3 py-2 w-full focus:ring-0 focus:outline-gray-400"
                                value={resolution}
                                onChange={(e) => set_resolution(e.target.value)}
                                disabled={!model || !model.meta || !model.meta.resolution_options}
                            >
                                {!model || !model.meta || !model.meta.resolution_options ? (
                                    <option value="">Select Model First</option>
                                ) : (
                                    <>
                                        {model.meta.resolution_options.map((res, index) => (
                                            <option key={index} value={res.value}>{res.label}</option>
                                        ))}
                                    </>
                                )}
                            </select>
                        </div>

                        <div>
                            <span className='text-sm font-semibold block mb-2'>
                                Quality
                            </span>
                            <select
                                className="border rounded-lg px-3 py-2 w-full focus:ring-0 focus:outline-gray-400"
                                value={quality}
                                onChange={(e) => set_quality(e.target.value)}
                                disabled={!model || !model.meta || !model.meta.quality_options}
                            >
                                {!model || !model.meta || !model.meta.quality_options ? (
                                    <option value="">Select Model First</option>
                                ) : (
                                    <>
                                        {model.meta.quality_options.map((qual, index) => (
                                            <option key={index} value={qual.value}>{qual.label}</option>
                                        ))}
                                    </>
                                )}
                            </select>
                        </div>
                    </div>

                    <div className='w-full flex justify-end mt-6'>
                        <button
                            className='text-base font-semibold px-3 py-2 bg-black rounded-lg text-white disabled:opacity-50'
                            onClick={handleGenerateImage}
                            disabled={responseLoading || !model}
                        >
                            {responseLoading ? 'Generating...' : 'Generate Image'}
                        </button>
                    </div>

                    <div className='bg-slate-100 p-3 mt-6 rounded-lg'>
                        {responseLoading ? (
                            <div className="flex justify-center items-center py-4">
                                <p>Generating image...</p>
                            </div>
                        ) : response && response.data ? (
                            <div>
                                <p className="font-semibold mb-2">Generated Image:</p>
                                    <div>
                                        <div className="flex justify-end items-center mb-2">
                                            <button
                                                className="text-sm bg-black text-white px-2 py-1 rounded hover:bg-gray-800"
                                                onClick={() => {
                                                    const link = document.createElement('a');
                                                    link.href = response.data.output
                                                    link.download = `generated-image.png`;
                                                    document.body.appendChild(link);
                                                    link.click();
                                                    document.body.removeChild(link);
                                                }}
                                            >
                                                Download
                                            </button>
                                        </div>
                                        <div className='flex justify-between space-x-6 w-full'>
                                        <img
                                            src={response.data.output || response.data.blob_url}
                                            alt="Generated"
                                            className="max-w-[400px] h-auto rounded border"
                                            onError={(e) => {
                                               console.error("failed" , e)
                                            }}
                                        />
                                        <div className='max-w-[50%] ml-3'><span className='font-bold text-sm'>Revised Prompt:</span><span> {response.data.revised_prompt}</span></div>
                                        </div>
                                    </div>
                            </div>
                        ) : (
                            <div className="text-center py-4 text-gray-500">
                                Generated images will appear here
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ImageGen;